export const ADD_TO_BASKET_ESI_WARNING_OR_ERROR =
  "ADD_TO_BASKET_ESI:WARNING_OR_ERROR";
export const ADD_TO_BASKET_ESI_SUCCESSFULLY_ADDED =
  "ADD_TO_BASKET_ESI:SUCCESSFULLY_ADDED";
export const ADD_TO_BASKET_ESI_QUANTITY_UPDATED =
  "ADD_TO_BASKET_ESI:QUANTITY_UPDATED";
export const ADD_TO_BASKET_ESI_LENGTH_UPDATED =
  "ADD_TO_BASKET_ESI:QUANTITY_UPDATED";
export const ADD_TO_BASKET_ESI_HIDDEN_OR_VISIBLE =
  "ADD_TO_BASKET_ESI:HIDDEN_OR_VISIBLE";
export const ADD_TO_BASKET_ESI_CHILD_ITEMS_UPDATED_POST_A2B =
  "ADD_TO_BASKET_ESI:CHILD_ITEMS_UPDATED:POST_A2B";
export const SIZE_SELECTOR_ERROR_NO_SIZE_SELECTED =
  "SIZE_SELECTOR:ERROR_NO_SIZE_SELECTED";
export const ADD_TO_WISHLIST_ESI_WARNING_OR_ERROR =
  "ADD_TO_WISHLIST_ESI:WARNING_OR_ERROR";
export const WARNING_OR_ERROR_EVENT = "ADD_TO_BASKET_ESI:WARNING_OR_ERROR";
export const NO_VARIANT_CODE = "no-variant";
export const WISHLIST_NO_VARIANT_CODE = "no-size-selected";
export const OUT_OF_STOCK_CODE = "OUT_OF_STOCK_ONLINE";
export const CHILD_ITEMS_UPDATED_EVENT =
  "ADD_TO_BASKET_ESI:CHILD_ITEMS_UPDATED";

export const DELIVERY_SLOTS_CHECKER_SERVICES_CHANGED =
  "DELIVERY_SLOTS_CHECKER:SERVICES_CHANGED";

export const SERVICE_QUESTIONNAIRE_ESI_SERVICE_SELECTED =
  "SERVICE_QUESTIONNAIRE_ESI:SERVICE_SELECTED";
export const SERVICE_QUESTIONNAIRE_ESI_COMPLETE =
  "SERVICE_QUESTIONNAIRE_ESI:COMPLETE";
export const VIEW_ALL_REVIEWS = "jl-events.browser.viewAllReviews";

export const OFFERTYPE_REDUCED = "ReducedToClear";
export const OFFERTYPE_PROMOTION = "Promotion";

export const OFFERTYPESUMMARY_REDUCED = "ReducedToClear";
export const OFFERTYPESUMMARY_SELECTED_REDUCED = "SelectedReducedToClear";
export const OFFERTYPESUMMARY_PROMOTION = "Promotion";
export const OFFERTYPESUMMARY_SELECTED_PROMOTION = "SelectedPromotion";
export const SUPPLIER_DIRECT_DMS_ID = "14";
export const RECOMMENDATIONS_PANEL_LOADED =
  "jl-recommendations-panel:productsLoaded";
export const MOBILE_HEADER_PEEP_UPDATED =
  "jl-events.browser.mobileHeaderPeepUpdated";

export const FREE_DELIVERY_THRESHOLD = 50;
export const FREE_CLICK_AND_COLLECT_THRESHOLD = 40;

export const MANDATORY_SERVICES = [];

export enum DMS_IDS {
  OnePersonDelivery = "1",
  NextOrNamedDayDelivery = "5",
  EveningDeliveryM25 = "11",
  SupplierDelivery = "14",
  TwoPersonDelivery = "26",
  M2MDelivery = "155",
  ClickAndCollect = "187",
  NextDayDelivery = "202",
  MorningDelivery = "271",
  LocalCollectionNetwork = "413",
  SupplierDeliveryCondor = "422",
}

export const FREE_DELIVERY_THRESHOLD_DMS_IDS: readonly string[] = [
  DMS_IDS.OnePersonDelivery,
  DMS_IDS.SupplierDelivery,
  DMS_IDS.M2MDelivery,
  DMS_IDS.SupplierDeliveryCondor,
];
